import type { Database } from './database';

export type Customer = Database['public']['Tables']['users']['Row'];
export type Account = Database['public']['Tables']['accounts']['Row'];
export type Card = Database['public']['Tables']['cards']['Row'];
export type Transaction = Database['public']['Tables']['transactions']['Row'];
export type Beneficiary = Database['public']['Tables']['beneficiaries']['Row'];
export type Device = Database['public']['Tables']['devices']['Row'];
export type Session = Database['public']['Tables']['sessions']['Row'];
export type AppEvent = Database['public']['Tables']['app_events']['Row'];

// Customer search filters
export interface CustomerSearchFilters {
  query?: string;
  status?: Customer['account_status'];
  country?: string;
  nationality?: string;
  has_open_cases?: boolean;
}

// Customer with aggregated data
export interface CustomerWithStats extends Customer {
  account_count: number;
  total_balance: number;
  open_cases_count: number;
  last_transaction_date: string | null;
  last_login_date: string | null;
}

// Transaction filters
export interface TransactionFilters {
  account_id?: string;
  transaction_type?: Transaction['transaction_type'];
  status?: Transaction['status'];
  date_from?: string;
  date_to?: string;
  min_amount?: number;
  max_amount?: number;
  search?: string;
}

// Helper functions
export const getCustomerFullName = (customer: Customer): string => {
  return `${customer.first_name} ${customer.last_name}`;
};

export const getAccountStatusColor = (status: Customer['account_status']): string => {
  const colors: Record<Customer['account_status'], string> = {
    active: 'green',
    suspended: 'orange',
    closed: 'red',
  };
  return colors[status];
};

export const getTransactionTypeColor = (type: Transaction['transaction_type']): string => {
  return type === 'credit' ? 'green' : 'red';
};

export const formatCurrency = (amount: number, currency: string = 'AED'): string => {
  return `${currency} ${amount.toLocaleString('en-AE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const maskCardNumber = (cardNumber: string): string => {
  if (cardNumber.length !== 16) return cardNumber;
  return `**** **** **** ${cardNumber.slice(-4)}`;
};

export const maskIBAN = (iban: string): string => {
  if (iban.length < 8) return iban;
  return `${iban.slice(0, 4)}****${iban.slice(-4)}`;
};

